import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import AuthUser from "../../services/AuthUser";
import CitySelector from "./CitySelectore";
import Footer from "../footer";
import WhatsAppScrollButton from "../floatingwhatsApp";
import CircularScrollProgress from "../Circularprogress";
import RightSidebarAds from "../Agent/TopRightAd";
import { ServicesContext } from "../../services/ServicesContext";
import { handleRazorpayPayment } from "../../services/handlePayment";
import { useLocation, useNavigate } from "react-router-dom";





const Bookservice = () => {
    const [selectedService, setSelectedService] = useState("");
    const [showCity, setShowCity] = useState(false);
    const [errors, setErrors] = useState({});
    const { http } = AuthUser();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone_number: "",
        serviceset: "",
        category: "0",
        employeno: "0",
        city: "",
        plans: ''
    });
    const [newData, setNewData] = useState({
        name: "",
        email: "",
        phone_number: "",

    });

    const optionsMap = {
        "Online Accounting and Bookkeeping Service": {
            plans: ["Basic", "Pro"],
            requiresTurnover: false,
            price: {
                Basic: 500,
                Pro: 500
            }
        },
        "Online GST Return Filing": {
            plans: ["Monthly", "Quarterly", "Yearly"],
            requiresTurnover: true,
            turnoverOptions: [
                { value: "option1", label: "NIL (Bills Cover 3)", price: { Monthly: 250, Quarterly: 600, Yearly: 2000 } },
                { value: "option2", label: "Rs.1 to Upto 15 Lac (Bills Cover 15)", price: { Monthly: 400, Quarterly: 1000, Yearly: 3600 } },
                { value: "option3", label: "15 Lac to 60 Lac (Bills Cover 30)", price: { Monthly: 600, Quarterly: 1200, Yearly: 4000 } },
                { value: "option4", label: "60 Lac to 1.50 Crore (Bills Cover 60)", price: { Monthly: 750, Quarterly: 1800, Yearly: 6000 } },

            ]
        },
        "E-Filing Income Tax": {
            plans: ["Plan 500", "Salary 860", "Business 860", "Premium"],
            requiresTurnover: false,
            price: {
                "Plan 500": 500,
                "Salary 860": 860,
                "Business 860": 860,
                "Premium": 3200
            }
        },
        "TDS Return Filing": {
            plans: ["Basic", "Starter"],
            requiresTurnover: true,
            turnoverOptions: [
                { value: "option1", label: "0 to 50 Parties / Deductees", price: { Basic: 2250, Starter: 3250 } },
                { value: "option2", label: "50 to 250 Parties / Deductees", price: { Basic: 7250, Starter: 12250 } },
                { value: "option3", label: "250 to 500 Parties / Deductees", price: { Basic: 24250, Starter: 24250 } },
                { value: "option4", label: "500 to 800 Parties / Deductees", price: { Basic: 36250, Starter: 36250 } },

            ]
        },
        "PF And ESIC Return Filing": {
            plans: ["PF", "ESIC"],
            requiresTurnover: true,
            turnoverOptions: [
                { value: "option1", label: "01 to 20 Employees", price: { PF: 3250, ESIC: 1250 } },
                { value: "option2", label: "21 to 40 Employees", price: { PF: 7250, ESIC: 2250 } },
                { value: "option3", label: "41 to 75 Employees", price: { PF: 12250, ESIC: 3250 } },
                { value: "option4", label: "76 to 100 Employees", price: { PF: 24250, ESIC: 4250 } },
                { value: "option5", label: "101 to 150 Employees", price: { PF: 36250, ESIC: 5250 } },

            ]
        },
    };
    const availablePlans = optionsMap[formData.serviceset] || [];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setNewData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const { services: allServices, loading, error } = useContext(ServicesContext);

    const service = allServices.find(s => s.service_name === selectedService);

    console.log("services:", allServices);
    console.log("service:", service);

    const [services, setServices] = useState([]);

    useEffect(() => {
        http.get("/services")
            .then((response) => {
                setServices(response.data);
            })
            .catch((error) => {
                console.error("Error fetching services:", error);
            });
    }, []);

    const handleServiceChange = (event) => {
        const selectedValue = event.target.value;
        setSelectedService(selectedValue);
        setShowCity(selectedValue !== "");

        // Update the service field in formData
        setFormData((prev) => ({
            ...prev,
            serviceset: selectedValue,
        }));
    };

    const handleSubmit = async (paymentData = null) => {

        console.log("paymentData:", paymentData);

        // Get agent object from local storage
        const agentData = localStorage.getItem("agent");

        // Parse the JSON string to an object
        let uniqId = "";
        if (agentData) {
            const agent = JSON.parse(agentData); // Convert string to JSON object
            uniqId = agent.user_id; // Extract uniq_id
        }

        // Step 2: Prepare form data (from either form input or Razorpay callback)
        let finalPayload;

        if (paymentData) {
            // Called after Razorpay payment success
            finalPayload = {
                ...paymentData,
                agent_id: uniqId,
                select_tenure: JSON.stringify({
                    transactions: paymentData.transactions,
                    accounting: paymentData.accounting,
                    accountingFor: paymentData.accountingFor,
                }),
            };
        } else {
            // Called normally via form submit
            const updatedFormData = { ...formData, agent_id: uniqId };

            finalPayload = {
                ...updatedFormData,
                select_tenure: JSON.stringify({
                    transactions: formData.transactions,
                    accounting: formData.accounting,
                    accountingFor: formData.accountingFor,
                }),
            };
        }





        setNewData(finalPayload)

        try {

            const response = await http.post("/book-service", finalPayload, {
                headers: {
                    "Content-Type": "application/json", // Ensure correct content type
                }
            });

            // alert("Service booked successfully!");
            setFormData({
                name: "",
                email: "",
                phone_number: "",
                serviceset: "",
                category: "0",
                employeno: "0",
                city: "",
                plans: ''
            });

            setSelectedService('');
        } catch (error) {
            console.error("Error submitting form:", error.response?.data || error.message);

            let errorMessage = "Failed to book service!";

            if (error.response && error.response.data) {
                const errors = error.response.data.errors;

                if (errors) {
                    // Prioritize service error if it exists
                    if (errors.serviceset && errors.serviceset.length > 0) {
                        errorMessage = errors.serviceset[0];
                    } else if (errors.city && errors.city.length > 0) {
                        errorMessage = errors.city[0];
                    } else if (error.response.data.message) {
                        errorMessage = error.response.data.message;
                    }
                } else if (error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
            }

            alert(errorMessage);
        }
    };

    const buildPayload = () => {
        const agentData = localStorage.getItem("agent");
        let uniqId = "";

        if (agentData) {
            const agent = JSON.parse(agentData);
            uniqId = agent.user_id;
        }

        const updatedFormData = { ...formData, agent_id: uniqId };

        // Determine price based on selected service, plan, and turnover
        let price = 0;

        console.log("Selected Service:", selectedService);
        console.log("Options Map for Selected Service:", optionsMap[selectedService]);
        console.log("Form Data Plans:", formData.plans);
        console.log("Form Data Turnover:", formData.turnover);

        if (selectedService && optionsMap[selectedService]) {
            const service = optionsMap[selectedService];
            const plan = formData.plans;

            if (service.requiresTurnover) {
                const turnoverValue = formData.turnover;

                const selectedTurnover = service.turnoverOptions.find(
                    (option) => option.value === turnoverValue
                );

                if (selectedTurnover && selectedTurnover.price && plan in selectedTurnover.price) {
                    price = selectedTurnover.price[plan];
                }
            } else {
                if (service?.price && plan in service?.price) {
                    price = service?.price[plan];
                }
            }
        }

        console.log("Calculated Price:", price);

        // Final payload
        const payload = {
            ...updatedFormData,
            select_tenure: JSON.stringify({
                transactions: formData.transactions,
                accounting: formData.accounting,
                accountingFor: formData.accountingFor,

            }),
            planprice: price
        };

        return payload;
    };




    const formPutPartenshipdeed = async (e) => {
        console.log('formData:', formData)

        // Step 1: Simple frontend validation (you can expand this)
        const newErrors = {};
        if (!formData.name) newErrors.name = "*Name is required";
        if (!formData.email) newErrors.email = "*Email is required";
        if (!formData.phone_number) newErrors.phone_number = "*Contact number is required";
        if (!formData.serviceset) newErrors.serviceset = "*service is required";
        if (!formData.city) newErrors.city = "*city is required";


        // Add this:
        if (selectedService === "Online Accounting and Bookkeeping Service") {
            if (!formData.transactions) newErrors.transactions = "*Annual Transactions is required";
            if (!formData.accounting) newErrors.accounting = "*Accounting option is required";
            if (!formData.accountingFor) newErrors.accountingFor = "*Accounting For is required";
        }


        const cleanService = selectedService.replace(/\s+/g, " ").trim();

        // Conditionally validate category
        if (
            cleanService === "IEC Registration Online Apply for" ||
            cleanService === "MSME Registration Online"
        ) {
            if (!formData.category || formData.category === "0") {
                newErrors.category = "*Please select a valid category";
            }
        }

        // ✅ Conditionally validate Plan
        if (selectedServiceData?.plans && !formData.plans) {
            newErrors.plans = "*Please select a plan";
        }

        // ✅ Conditionally validate Turnover
        if (selectedServiceData?.requiresTurnover && !formData.turnover) {
            newErrors.turnover = "*Please select a turnover";
        }

        // Step 2: Show errors if found
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return; // 🔴 Stop here, don’t proceed to payment
        }


        const payload = buildPayload(); // Build the payload before calling Razorpay

        console.log('formData:', formData)
        console.log('payload:', payload)


        const newData = {
            ...formData,
            // maybe add other data like:
            timestamp: new Date().toISOString()
        };

        localStorage.setItem("bookingData", JSON.stringify(newData));

        // Navigate to checkout
        navigate('/checkout', {
            state: { service } // optional, can also store in localStorage
        });
    };


    const selectedServiceData = optionsMap[selectedService];


    return (
        <div>
            <div className="row">
                <div className="col-8">
                    <div className="container mt-5 d-flex justify-content-center align-items-center" >
                        <div className="col-12 col-md-11 card p-5 shadow-lg">
                            <h2>Book a Service</h2>
                            {/* <form onSubmit={handleSubmit}> */}
                            <form>
                                <div className="form-group">
                                    <label htmlFor="name">Full Name</label>
                                    {errors.name && <p className="error-text">{errors.name}</p>}
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        className="form-control"
                                        placeholder="Enter your full name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="email">Email Address</label>
                                    {errors.email && <p className="error-text">{errors.email}</p>}
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        className="form-control"
                                        placeholder="Enter your email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="phone">Phone Number</label>
                                    {errors.phone_number && <p className="error-text">{errors.phone_number}</p>}
                                    <input
                                        type="text"
                                        id="phone"
                                        name="phone_number"
                                        className="form-control"
                                        placeholder="Enter your phone number"
                                        value={formData.phone_number}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="serviceset">Select Service</label>
                                    {errors.serviceset && <p className="error-text">{errors.serviceset}</p>}
                                    <select
                                        id="serviceset"
                                        name="service"
                                        className="form-control"
                                        value={selectedService}
                                        onChange={handleServiceChange}
                                        required
                                    >
                                        <option hidden>Select a service</option>
                                        {services.map((service) => (
                                            <option key={service.service_id} value={service.service_name}>
                                                {service.service_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {showCity && (
                                    <div className="form-group">

                                        <CitySelector
                                            newData={formData}
                                            setNewData={setFormData}
                                            fieldKey="city"
                                            errors={errors}
                                        />
                                    </div>
                                )}
                                {/* Plan Dropdown */}
                                {selectedServiceData?.plans && (
                                    <div className="form-group">
                                        <label htmlFor="plans">Plan</label>
                                        {errors.plans && <p className="error-text">{errors.plans}</p>}
                                        <select
                                            id="plans"
                                            name="plans"
                                            className="form-control"
                                            value={formData.plans}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="" hidden>Select a plan</option>
                                            {selectedServiceData.plans.map((plan) => (
                                                <option key={plan} value={plan}>
                                                    {plan}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}

                                {/* Turnover Dropdown */}
                                {selectedServiceData?.requiresTurnover && (
                                    <div className="form-group">
                                        <label htmlFor="turnover">Turnover</label>
                                        {errors.turnover && <p className="error-text">{errors.turnover}</p>}
                                        <select
                                            id="turnover"
                                            name="turnover"
                                            className="form-control"
                                            value={formData.turnover}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="" hidden>Select a turnover</option>
                                            {selectedServiceData.turnoverOptions.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                )}


                                {selectedService === "Online Accounting and Bookkeeping Service" && (
                                    <>
                                        <div className="form-group">
                                            <label htmlFor="transactions">Annual Transactions</label>
                                            {errors.transactions && <p className="error-text">{errors.transactions}</p>}
                                            <select
                                                id="transactions"
                                                name="transactions"
                                                className="form-control"
                                                value={formData.transactions || ""}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="" hidden>Select an option</option>
                                                <option value="0 to 500 Transactions">0 to 500 Transactions</option>
                                                <option value="500 to 1200 Transactions">500 to 1200 Transactions</option>
                                                <option value="1200 to 2500 Transactions">1200 to 2500 Transactions</option>
                                                <option value="2500 to 5000 Transactions">2500 to 5000 Transactions</option>
                                                <option value="5000 to 7500 Transactions">5000 to 7500 Transactions</option>
                                                <option value="More Than 7500">More Than 7500</option>
                                            </select>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="accounting">Accounting</label>
                                            {errors.accounting && <p className="error-text">{errors.accounting}</p>}
                                            <select
                                                id="accounting"
                                                name="accounting"
                                                className="form-control"
                                                value={formData.accounting || ""}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="" hidden>Select an option</option>
                                                <option value="Accounting with Inventory">Accounting with Inventory</option>
                                                <option value="Accounting without Inventory">Accounting without Inventory</option>
                                            </select>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="accountingFor">Accounting for</label>
                                            {errors.accountingFor && <p className="error-text">{errors.accountingFor}</p>}
                                            <select
                                                className="form-control"
                                                id="accountingFor"
                                                name="accountingFor"
                                                value={formData.accountingFor || ""}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="" hidden>Select an option</option>
                                                <option value="Accounting for Service Provider">Accounting for Service Provider</option>
                                                <option value="Accounting Supervision / Checking">Accounting Supervision / Checking</option>
                                                <option value="Accounting Consultancy">Accounting Consultancy</option>
                                            </select>
                                        </div>
                                    </>
                                )}

                                {(selectedService.replace(/\s+/g, " ").trim() === "IEC Registration Online Apply for" ||
                                    selectedService === "MSME Registration Online" ||
                                    selectedService === "Balance Sheet Preparation" ||
                                    selectedService === "Professional Tax Registration" ||
                                    selectedService === "PF And ESIC Registration") && (
                                        <div className="form-group">
                                            <label htmlFor="category">Category</label>
                                            {errors.category && <p className="error-text">{errors.category}</p>}
                                            <select
                                                id="category"
                                                name="category"
                                                className="form-control"
                                                value={formData.category || "0"}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option className="formop" data-display="Select Category...">Select Category...</option>
                                                <option value="Sole Proprietorship / Individual">Sole Proprietorship / Individual</option>
                                                <option value="Partnership / LLP">Partnership / LLP</option>
                                                <option value="Private limited / Public limited / One person company">Private limited / Public limited / One person company</option>
                                                <option value="HUF">HUF</option>
                                                <option value="Society / Trust / Club">Society / Trust / Club</option>
                                            </select>
                                        </div>
                                    )}

                                {/* {(selectedService === "Income Tax Registration" ) && (
                                    <div className="form-group">
                                        <label htmlFor="employeno">Employee Number</label>
                                        <input
                                            type="text"
                                            id="employeno"
                                            name="employeno"
                                            className="form-control"
                                            placeholder="Enter employee number"
                                            value={formData.employeno}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                )} */}

                                {/* <button type="submit" className="btn btn-primary">Submit</button> */}
                                <button type="button" className="btn btn-primary" onClick={formPutPartenshipdeed}>Submit</button>

                            </form>
                        </div>
                    </div>
                </div>
                <div className="col-4">
                    <div className="mt-5 p-3 rounded adds shadow" style={{ backgroundColor: '#f1f9ff', border: '2px solid #a0d4ff' }}>
                        <h4 className="text-primary mb-3 text-center">🔥 Trending Ads</h4>
                        <RightSidebarAds />
                    </div>
                </div>
            </div>

            <div className="space40 bg-white"></div>
            <WhatsAppScrollButton />
            <Footer />
            <CircularScrollProgress />
        </div>
    );
};

export default Bookservice;
